export default __webpack_public_path__ + "static/media/paddy.7fd8f2dd.png";